import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, borderRadius } = useTheme();

  return {
    middle: css`
      display: grid;
      border-top: 1px solid ${colors.lightGrey};
      margin: 0 ${spacing.m};
      padding: ${spacing.s} 0 ${spacing.xs};

      ${breakpoints.m} {
        margin: 0 ${spacing.m};
        padding: ${spacing.l} 0;
      }

      ${breakpoints.l} {
        margin: 0 ${spacing.xxl};
      }
    `,
    title: css`
      color: ${colors.navy};
      position: relative;
      margin: ${spacing.s} 0;
      font-size: 1.25rem;
      display: inline-block;
      padding-bottom: 10px;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 15%;
        border-bottom: 2px solid ${colors.red};
      }

      ${breakpoints.m} {
        font-size: 1.5rem;
        &::after {
          width: 5%;
        }
      }
    `,
    rightContent: css`
      border-top: ${borderRadius.s} solid ${colors.red};
      padding: ${spacing.s};
      background-color: ${colors.lightGrey};
    `,
    wrapText: css`
      white-space: pre-wrap;
    `,
    venueFacilitiesWrapper: css`
      padding: ${spacing.xs} 0;
    `,
    eventsTitle: css`
      margin-bottom: ${spacing.xs};

      ${breakpoints.l} {
        margin-bottom: ${spacing.s};
      }
    `,
    faInititativeWrapper: css`
      background-color: ${colors.lightGrey};

      ${breakpoints.m} {
        border-radius: 0 0 ${borderRadius.xxl} ${borderRadius.xxl};
      }
    `,
    events: css`
      grid-gap: 0.3rem;
      display: flex;
      flex-wrap: wrap;

      ${breakpoints.m} {
        grid-gap: 0;
      }

      img {
        border-radius: ${borderRadius.l};
      }

      > div {
        width: 100%;
        margin-bottom: 1.5rem;

        ${breakpoints.m} {
          margin-right: ${spacing.m};
          margin-bottom: 0;
          flex: 1;
          max-width: 50%;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    `,
  };
};
